import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

export const MaterialSelect = styled(Select)(({ theme, ...props }) => ({
  backgroundColor: props.secondary ? theme.palette.colors.surfaceElevatedStrong : theme.palette.colors.inputSurface,
  minHeight: props?.small ? 42 : 48,
  borderRadius: 14,
  padding: '0 8px',
  border: `1px solid ${theme.palette.colors.inputBorder}`,
  color: theme.palette.colors.text,
  boxShadow: `inset 0 1px 0 ${theme.palette.colors.borderSoft}`,
  transition: 'border-color 0.22s ease, box-shadow 0.22s ease, background-color 0.22s ease',
  '&:hover': {
    borderColor: theme.palette.colors.borderStrong,
  },
  '&.Mui-focused': {
    borderColor: theme.palette.blue.main,
    boxShadow: `0 0 0 4px ${theme.palette.colors.badgeMuted}`,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.colors.panelBackdrop,
    color: theme.palette.colors.disabledText,
    borderColor: theme.palette.colors.borderSoft,
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    minHeight: 'unset',
    padding: '11px 34px 11px 4px !important',
    color: theme.palette.colors.text,
  },
  '& .MuiSelect-icon': {
    color: theme.palette.colors.subdued,
    right: 12,
  },
  '& .MuiInputAdornment-root': {
    color: theme.palette.colors.subdued,
  },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  fontSize: "1rem",
  transform: "translate(0, -8px) scale(1)",
  transformOrigin: "top left",
  color: theme.palette.colors.muted,
  fontWeight: 600,
  letterSpacing: '0.01em',
  '&.MuiInputLabel-root, &.Mui-focused, &.MuiFormLabel-colorPrimary, &.MuiFormLabel-colorSecondary': {
    color: theme.palette.colors.muted,
  },
  '& > b': {
    color: theme.palette.error.main,
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.colors.text,
  backgroundColor: theme.palette.colors.surfaceElevated,
  fontSize: 15,
  '&:hover': {
    backgroundColor: theme.palette.colors.badgeMuted,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.colors.badgeMuted,
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.colors.badgeMuted,
  },
}));
